export const copies = {
  es: {
    title: 'suplementos',
    normal: 'Añade cualquier suplemento a tu pizza por 1,75€',
    special: 'Anchoas, Gambas, Queso de cabra, Roquefort 2,70€',
    smoked: 'Ahumados 3,80€',
    alergies:
      '*Todas nuestras pizzas contienen gluten (harina de trigo) y lácteos (mozzarella), para cualquier duda pregunte al camarero/a'
  },
  cat: {
    title: 'suplements',
    normal: 'Afegeix qualsevol suplement a la pizza per 1,75€',
    special: 'Anxoves, gambes, formatge de cabra o roquefort 2,70€',
    smoked: 'Fumats 3,80€',
    alergies:
      '*Totes les nostres pizzes contenen gluten (farina de blat) i lactis (mozzarella), per a qualsevol dubte pregunti al cambrer'
  }
}
